import { useWorkplacesClient } from "../../../api/grpc/workplaces/useWorkplacesClient";
import useGrpcQuery from "../../../lib/hooks/useGrpcQuery";
import { useBookingsMapContext } from "../BookingsMap/Context/BookingsMapContext";

import {
  DesksListResponse,
  SearchAccountDesksRequest,
} from "../../../api/grpc/workplaces/workplaces";

export const useAssignedDesks = () => {
  const { getAssignedDesks } = useWorkplacesClient();
  const { bookOnBehalfUser } = useBookingsMapContext();

  const {
    loading,
    error,
    data: assignedDesks,
    refetch: refetchAssignedDesks,
  } = useGrpcQuery<SearchAccountDesksRequest, DesksListResponse>({
    method: getAssignedDesks,
    variables: {
      accountID: bookOnBehalfUser ? bookOnBehalfUser.accountID : "",
      customerID: bookOnBehalfUser ? bookOnBehalfUser.customerID : "",
    },
    refetchOnWindowFocus: true,
    refetchOnWindowFocusThreshold: 30000,
  });

  return { loading, error, assignedDesks, refetchAssignedDesks };
};
